var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMasterIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 59,
    height: 39,
    viewBox: "0 0 59 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_252_5429)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M54 0.5H5C2.51472 0.5 0.5 2.51472 0.5 5V34C0.5 36.4853 2.51472 38.5 5 38.5H54C56.4853 38.5 58.5 36.4853 58.5 34V5C58.5 2.51472 56.4853 0.5 54 0.5Z",
    stroke: "#3D2C06"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.9969 31.0026C26.9299 31.0026 21.9941 26.0668 21.9941 19.9998C21.9941 13.9328 26.9299 8.99707 32.9969 8.99707C39.0639 8.99707 43.9997 13.9328 43.9997 19.9998C43.9997 26.0668 39.0638 31.0026 32.9969 31.0026Z",
    fill: "#3D2C06"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.5838 30.6962C18.6762 32.3629 12 27.1141 12 19.9999C12 12.8943 18.6676 7.63484 25.5838 9.30369C18.1105 14.4993 18.1137 25.503 25.5838 30.6962Z",
    fill: "#3D2C06"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_252_5429"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 59,
    height: 39,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMasterIcon);
export default __webpack_public_path__ + "static/media/masterIcon.b1c62eff12f4b315980fc9bcaec6e20d.svg";
export { ForwardRef as ReactComponent };